import { Fragment, useEffect, useRef } from 'react';
import { Layout, CtaForm } from '../../components';

import { ONBOARDING_DATA } from '../../data/onboarding';
import Link from 'next/link';
import Parser from 'html-react-parser';
import { useRouter } from 'next/router';

function renderItem(item) {
	if (typeof item === 'string') {
		return Parser(item);
	} else if (typeof item === 'object' && item !== null) {
		const subItems = Object.entries(item).map(([title, subItems]) => (
			<div key={title}>
				{title}
				<ul className="fa-ul">
					{subItems?.map((subItem, subIndex) => (
						<li key={subIndex}>
							<span className="fa-li">
								<i className="fas fa-check"></i>
							</span>
							{subItem}
						</li>
					))}
				</ul>
			</div>
		));
		return subItems;
	}
}

export default function Onboarding() {
	const router = useRouter();
	useEffect(() => {
		// Function to scroll to the target div with offset Y -100
		const scrollToEnhancedOnboarding = () => {
			const targetDiv = document.querySelector('#enhanced-onboarding');
			if (targetDiv) {
				const yOffset = -100;
				const y = targetDiv.getBoundingClientRect().top + window.scrollY + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
			}
		};

		// Check if the current URL contains the target ID
		const currentURLHasTargetID = router.asPath.includes('#enhanced-onboarding');

		if (currentURLHasTargetID) {
			// If the ID is in the URL, scroll to the target div
			setTimeout(scrollToEnhancedOnboarding, 0); // Execute on the next tick
		}

		// Listen for route changes and check if the ID is in the new URL
		const handleRouteChange = (url) => {
			if (url.includes('#enhanced-onboarding')) {
				// If the ID is in the new URL, scroll to the target div
				setTimeout(scrollToEnhancedOnboarding, 0); // Execute on the next tick
			}
		};

		router.events.on('routeChangeComplete', handleRouteChange);

		// Cleanup the event listener when the component unmounts
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router]);

	return (
		<Layout pageName="Onboarding">
			<div
				className="
            resource-page resource-page--onboarding"
			>
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Onboarding</h1>

							<h2 className="heading__desc">
								FacilityBot's Onboarding Team is here to help all our clients get the most with FacilityBot
							</h2>
						</div>
					</div>
				</section>

				{ONBOARDING_DATA.map((section) => {
					const { title, content, id } = section;
					return (
						<section className="instructions" id={id}>
							<div className="container">
								<div className="instructions-wrapper">
									<h2 className="instructions__title">{title}</h2>

									{content.map((item) => {
										const { description, list } = item;
										return (
											<Fragment>
												<div className="instructions__description">{description}</div>

												<div className="instructions__list">
													<ol className="fa-ul">
														{list?.map((li) => {
															return (
																<li>
																	<span className="fa-li">
																		<i className="fas fa-hand-point-right"></i>
																	</span>
																	<span>{renderItem(li)}</span>
																</li>
															);
														})}
													</ol>
												</div>
											</Fragment>
										);
									})}
								</div>
							</div>
						</section>
					);
				})}

				<div className="pricing-wrapper">
					<div className="container">
						<h2 className="pricing-wrapper__title">
							<div>Standard Onboarding is included in all subscriptions.</div>
							<div>
								Enhanced Onboarding is available at a one time cost of{' '}
								<span style={{ color: 'var(--primary)' }}>USD 2,000</span>.
							</div>
						</h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm />
			</div>
		</Layout>
	);
}
